import { render } from "./DuelsGameUsers.vue?vue&type=template&id=0d7ca730&scoped=true"
import script from "./DuelsGameUsers.vue?vue&type=script&lang=js"
export * from "./DuelsGameUsers.vue?vue&type=script&lang=js"

import "./DuelsGameUsers.vue?vue&type=style&index=0&id=0d7ca730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7ca730"]])

export default __exports__